// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#fc127f","loader":"loader__2dTST","sk-scaleout":"sk-scaleout__3_mzI"};